export default function updateDataList(array, id, updates, subPath) {
    const index = array.findIndex(item => item.id === id);
    // console.log('updateDataList', array, id, updates, subPath);
    if (index === -1) {
        console.warn('Item with id', id, 'not found in array');
        return;
    }
    let target = array[index];
    if (typeof subPath === 'string' && subPath.length > 0) {
        // console.log('subPath', subPath);
        const keys = subPath.trim().split('.');
        for (const key of keys) {
            if (!target[key]) {
                // console.log('creating new key', key, 'in target', target);
                this.$set(target, key, {});
            }
            target = target[key];
        }
    }
    for (const [key, value] of Object.entries(updates)) {
        // console.log('updating key=', key, 'with value=', value, 'in target', target);
        this.$set(target, key, value);
    }
    this.forceUpdate();
};
/*
como usarla:
Cambiar uno o mas claves en objeto raíz:
this.updateDataList(this.list, 1, {
    status: 3,
    name: 'Nuevo nombre'
});
Cambiar uno o mas claves en subobjeto:
this.updateDataList(this.list, 1, 'info.job', {
    status: 5,
    type: 'remoto'
};
Notas:
    keyPath es opcional, solo la usas si los datos están en un subobjeto (jobs, details, etc.).
    La función usa this.$set en cada clave para asegurar la reactividad total en Vue 2.
*/
